import { Layout } from "./Layout";
import { ListTab } from "./ListTab";

export const ListPage = () => (
  <Layout activeTab="list">
    <ListTab />
  </Layout>
);
